import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRockClimbingNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_rock_climbing_normal_large_svg__clip0_138_138)">
        <path
          d="M7.39 36.86a9.158 9.158 0 003.47-.67 18.64 18.64 0 016.92-1.33h.94a24.01 24.01 0 015.41.63l18.54 4.4c.329.071.664.108 1 .11a4.266 4.266 0 004.26-4.27 13.101 13.101 0 00-4.94-10.31L23.36 9.67a3.694 3.694 0 00-5.57 1.15l-2.94 5.53a2.854 2.854 0 01-2.52 1.51h-1.06L9.2 13.99l1.63-1.95a3.158 3.158 0 10-5.22-.54l1.16 2.18-.39.39A21.642 21.642 0 000 29.47a7.4 7.4 0 007.39 7.39zm38.54-1.13a2.242 2.242 0 01-.86 1.78 2.291 2.291 0 01-1.94.43l-18.54-4.39c-1.75-.42-3.54-.648-5.34-.68l-2.26-4.25 28.93 6.85c.009.086.012.173.01.26zM16.62 17.29l2.94-5.53a1.736 1.736 0 012.55-.52l2.52 2.02-8.48 11.05 2.13.51 7.92-10.3 2.5 2.01-6.93 9.11 2.13.51 6.36-8.37 2.55 2.04-5.47 7.14 2.14.51 4.89-6.4 2.54 2.04-3.98 5.17 2.13.51 3.42-4.43 3.26 2.62a11.086 11.086 0 013.94 6.38l-29.94-7.09v-.01l-3.41-6.4a4.847 4.847 0 004.29-2.57zM7.41 9.42a1.152 1.152 0 011.611-.379 1.159 1.159 0 01.27 1.719l-1.1 1.32-.81-1.52a1.139 1.139 0 01.03-1.14zm.35 6.11l9.23 17.35c-2.082.071-4.141.47-6.1 1.18L3.918 20.944A19.88 19.88 0 017.76 15.53zm-4.81 7.86l6 11.3a6.804 6.804 0 01-1.563.171A5.4 5.4 0 012 29.47a19.672 19.672 0 01.95-6.08z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_rock_climbing_normal_large_svg__clip0_138_138">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsRockClimbingNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsRockClimbingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRockClimbingNormalLarge;
